module.exports = __webpack_public_path__ + "assets/img/efe055e2017cddd1f8a9688bfd548657.png";